import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { dismissWeatherBanner } from '../../../store/weather';
import inclementWeatherIcon from '../../../assets/svgs/inclementWeatherIcon.svg';
import styles from './index.module.css';

export const WeatherAlertBanner = () => {
  const dispatch = useDispatch();
  const { hasAlert, alerts, locations, dismissed } = useSelector((state) => state.weather);

  if (!hasAlert || dismissed) return null;

  const alertText = locations?.length > 0
    ? locations.map((l) => `${l.locationName}: ${l.headline}`).join(' | ')
    : (alerts[0]?.headline ?? 'Inclement weather conditions detected in your area.');

  return (
    <div className={styles.banner}>
      <img
        src={inclementWeatherIcon}
        alt=""
        className={styles.icon}
        aria-hidden
      />
      <span className={styles.text}>
        <span className={styles.label}>Inclement Weather Alert:</span>{' '}
        <span className={styles.message}>{alertText}</span>
      </span>
      <div className={styles.closeArea}>
        <span className={styles.divider} aria-hidden />
        <button
          className={styles.closeBtn}
          onClick={() => dispatch(dismissWeatherBanner())}
          aria-label="Dismiss weather alert">
          &times;
        </button>
      </div>
    </div>
  );
};
